import styled from 'styled-components';

export const ContentContainer = styled.div`
  > iframe {
    border: none;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
  }
  height: 60vh;
`;
